import {Types} from "@Common/types";

type Agent  = Types.Apis.Payloads.Next.Agent.GetAll.Response[number];

export const mapAgentAsLabel = (agent:Pick<Agent, "agentLinkId" | "agentNameFirst" | "agentNameLast">): JSX.Element => (
    agent.agentLinkId ? (
        agent.agentNameLast + ", " + agent.agentNameFirst + ` (${agent.agentLinkId})`
    ) : (
        agent.agentNameLast + ", " + agent.agentNameFirst
    )
);
